import React, { useEffect, useState } from "react";
import { Route, Truck, Users, ChevronRight } from "lucide-react";
import api, { NUM } from "@/lib/api";
import { Card } from "@/components/Cards";

const today = () => new Date().toISOString().slice(0, 10);

export default function ShipmentSummaryCard({ goTo }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/shipment/vehicles", { params: { date: today() } }).then((r) => setData(r.data)).catch(() => setData({ vehicles: [], unassigned: [] }));
  }, []);

  if (!data || data.vehicles.length === 0) return null;

  const grandTotal = data.vehicles.reduce((s, v) => s + (v.total_headcount || 0), 0);

  return (
    <Card className="p-5" data-testid="dashboard-shipment-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading text-lg font-semibold flex items-center gap-2"><Route className="h-4.5 w-4.5 text-primary" style={{ width: 18, height: 18 }} /> Bugünkü Sevkiyat</h3>
          <p className="text-xs text-muted-foreground mt-0.5">{data.vehicles.length} araç · seçili günün kişi girişinden</p>
        </div>
        <button onClick={() => goTo && goTo("shipment")} className="text-xs font-semibold text-primary inline-flex items-center gap-0.5 hover:underline" data-testid="dashboard-shipment-link">
          Detay <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="flex items-end gap-2 mb-4">
        <span className="font-mono font-bold text-3xl text-primary tabular-nums" data-testid="dashboard-shipment-total">{NUM(grandTotal)}</span>
        <span className="text-sm text-muted-foreground mb-1">toplam kişi</span>
      </div>

      <div className="space-y-1.5">
        {data.vehicles.map((v) => (
          <div key={v.id} className="flex items-center justify-between rounded-lg bg-muted/40 px-3 py-2" data-testid={`dashboard-shipment-vehicle-${v.id}`}>
            <span className="text-sm flex items-center gap-2 min-w-0">
              <Truck className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
              <span className="truncate">{v.name}</span>
              {v.route && <span className="text-xs text-muted-foreground truncate hidden sm:inline">· {v.route}</span>}
            </span>
            <span className="text-sm font-semibold tabular-nums shrink-0 inline-flex items-center gap-1"><Users className="h-3.5 w-3.5 text-muted-foreground" /> {v.total_headcount}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
